import React from "react";
import { MessageSquare } from "lucide-react";
import AIStudioTool from "./AIStudioTool";

const FIELDS = [
  { key: "brand_name", label: "Brand name", required: true,
    placeholder: "e.g. Herbally, Northwild, Sunrise Oat…" },

  { key: "product_name", label: "Product name",
    placeholder: "Optional — leave blank for brand-level ads" },

  { key: "category", label: "Category", required: true,
    placeholder: "e.g. Functional beverage, snack, personal care…" },

  { key: "campaign_goal", label: "Campaign objective", type: "select",
    options: [
      { value: "conversions", label: "Conversions" },
      { value: "traffic",     label: "Traffic" },
      { value: "awareness",   label: "Awareness" },
      { value: "engagement",  label: "Engagement / comments" },
    ] },

  { key: "target_communities", label: "Subreddits to prioritise", type: "textarea", rows: 2, wide: true,
    placeholder: "e.g. r/vegan, r/coldbrew, r/skincareaddiction — leave blank to let AI recommend",
    hint: "Comma-separated list. Warren will suggest more even if you leave this empty.",
    maxLength: 400 },

  { key: "key_benefits", label: "Key benefits", type: "textarea", rows: 2, wide: true,
    placeholder: "e.g. Cold-pressed, USDA-organic, 5 ingredients, made in Brooklyn…",
    maxLength: 600 },

  { key: "style", label: "Creative style",
    placeholder: "e.g. native, community-friendly, non-salesy, meme-adjacent",
    hint: "Reddit rewards authenticity — stay away from stock-photo vibes." },

  { key: "count",   label: "Creatives to generate", type: "number", min: 1, max: 4 },
  { key: "quality", label: "Render quality", type: "select",
    options: [
      { value: "low",    label: "Low — fastest" },
      { value: "medium", label: "Medium — balanced (recommended)" },
      { value: "high",   label: "High — slower, portfolio-ready" },
    ] },
];

const DEFAULTS = {
  brand_name: "", product_name: "", category: "", campaign_goal: "conversions",
  target_communities: "", key_benefits: "",
  style: "native, community-friendly, non-salesy",
  count: 2, quality: "medium",
};

export default function AIStudioRedditAds() {
  return (
    <AIStudioTool
      toolSlug="reddit-ads"
      name="Reddit Ads Manager"
      Icon={MessageSquare}
      tagline="Plan Reddit campaigns that feel native. Warren picks 5–7 subreddits worth targeting, drafts community-friendly ad copy, and renders creatives that won't get downvoted."
      fields={FIELDS}
      endpoint="/ai-studio/reddit-ads/generate"
      defaultValues={DEFAULTS}
      cta="Generate Reddit campaign"
      historyLabel="Your Reddit campaigns"
      formHeading="Brief the campaign"
    />
  );
}
